import React, { useEffect, useState } from "react";
import { useForm } from 'react-hook-form';
import Swal from "sweetalert2";
import '../libs/css/bootstrap.css';
import '../libs/css/style.css';
import '../libs/css/responsive.css';
import '../libs/css/custom-bootstrap-margin-padding.css';
import $ from "jquery";
import Loaders from "./Dashboards/Loaders";
import { useNavigate } from "react-router-dom";
import { API_ROUTES } from '../utils/constants';


export default function Login(props){
    useEffect(() => {document.title = "Login | Forthsoft"}, []);

    const { objectToFormData } = props;
    const rememberLogin = localStorage.getItem('rememberLoginFs');
    const rememberMe = rememberLogin ? true : false;
    const userInput = localStorage.getItem('userInputFs');
    const inputObject = JSON.parse(userInput);
    const isEmail = inputObject ? atob(inputObject.email) : '';
    const isPassword = inputObject ? atob(inputObject.password) : '';


    const { register, handleSubmit, formState: {errors, isSubmitting, isValid} } = useForm({
        mode: "onChange",
        defaultValues: {
            email: rememberMe ? isEmail : '',
            password: rememberMe ? isPassword : '',
            remember: rememberMe
        }
    });

    const {
        register: registerForgot,
        handleSubmit: handleSubmitForgot,
        formState: { errors: forgotErrors, isSubmitting: isSubmittingForgot, isValid: isForgotValid }
    } = useForm({ mode: "onChange" });

    const {
        register: registerOtp,
        handleSubmit: handleSubmitOtp,
        formState: { errors: otpErrors, isSubmitting: isSubmittingOtp, isValid: isOtpValid }
    } = useForm({ mode: "onChange" });

    const {
        register: registerReset,
        handleSubmit: handleSubmitReset,
        watch: watchReset,
        formState: { errors: resetErrors, isSubmitting: isSubmittingReset, isValid: isResetValid }
    } = useForm({ mode: "onChange" });

    const newPasswordValue = watchReset("new_password");

    const RESEND_WAIT_SECONDS = 900;

    const [showLogin, setShowLogin] = useState(true);
    const [showForgotPassword, setShowForgotPassword] = useState(false);
    const [showOtp, setShowOtp] = useState(false);
    const [showResetPassword, setShowResetPassword] = useState(false);
    const [resetEmail, setResetEmail] = useState('');
    const [resetToken, setResetToken] = useState('');
    const [resendTimer, setResendTimer] = useState(0);
    const [isChecked, setIsChecked] = useState(rememberMe);
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [showNewPassword, setShowNewPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        if (resendTimer <= 0) return;
        const timeout = setTimeout(() => setResendTimer((prev) => prev - 1), 1000);
        return () => clearTimeout(timeout);
    }, [resendTimer]);


    const userData = localStorage.getItem('userDataFs');
    const userObj = JSON.parse(userData);
    const isAuthenticated = { 'isLoggedIn': userObj !== null ? userObj.isLoggedIn : false }

    if(isAuthenticated.isLoggedIn){
        navigate("/dashboard");
    }

    const formatTimer = (seconds) => {
        const m = Math.floor(seconds / 60).toString().padStart(2, '0');
        const s = (seconds % 60).toString().padStart(2, '0');
        return `${m}:${s}`;
    }

    const forgotPassLink = (e) => {
        e.preventDefault();
        setShowLogin(false);
        setShowForgotPassword(true);
    }

    const backToLogin = (e) => {
        if (e) e.preventDefault();
        setShowLogin(true);
        setShowForgotPassword(false);
        setShowOtp(false);
        setShowResetPassword(false);
        setResetEmail('');
        setResetToken('');
        setResendTimer(0);
    }

    const togglePassword = () => {
        setShowPassword(!showPassword);
    }

    const toggleNewPassword = () => {
        setShowNewPassword(!showNewPassword);
    }

    const toggleConfirmPassword = () => {
        setShowConfirmPassword(!showConfirmPassword);
    }

    const requestResetCode = async (data) => {
        try {
            const response = await fetch(API_ROUTES.FORGOT_PASSWORD, {
                method: "POST",
                body: objectToFormData({ email: data.email }),
            });
            const responseJSON = await response.json();

            if (responseJSON.status.toString() === "200") {
                setResetEmail(data.email);
                setShowForgotPassword(false);
                setShowOtp(true);
                setResendTimer(RESEND_WAIT_SECONDS);
                Swal.fire({
                    title: 'Code Sent',
                    html: responseJSON.message || 'A reset code has been sent to your email.',
                    icon: 'success',
                    timer: 2000,
                    showConfirmButton: false,
                });
            } else {
                Swal.fire({
                    title: "<font className='error_title'>Error</font>",
                    html: `${responseJSON.message}`,
                    icon: "error"
                });
            }
        } catch (error) {
            Swal.fire({
                icon:   "error",
                html:   error,
                title:  "Error",
            });
        }
    }

    const resendCode = async () => {
        if (resendTimer > 0) return;
        try {
            const response = await fetch(API_ROUTES.RESEND_TOKEN, {
                method: "POST",
                body: objectToFormData({ email: resetEmail }),
            });
            const responseJSON = await response.json();

            if (responseJSON.status.toString() === "200") {
                setResendTimer(RESEND_WAIT_SECONDS);
                Swal.fire({
                    title: 'Code Resent',
                    html: responseJSON.message || 'A new code has been sent to your email.',
                    icon: 'success',
                    timer: 2000,
                    showConfirmButton: false,
                });
            } else {
                Swal.fire({
                    title: "<font className='error_title'>Error</font>",
                    html: `${responseJSON.message}`,
                    icon: "error"
                });
            }
        } catch (error) {
            Swal.fire({
                icon:   "error",
                html:   error,
                title:  "Error",
            });
        }
    }

    const verifyResetCode = async (data) => {
        try {
            const response = await fetch(API_ROUTES.VERIFY_RESET_TOKEN, {
                method: "POST",
                body: objectToFormData({ email: resetEmail, reset_token: data.reset_token }),
            });
            const responseJSON = await response.json();

            if (responseJSON.status.toString() === "200") {
                setResetToken(data.reset_token);
                setShowOtp(false);
                setShowResetPassword(true);
            } else {
                Swal.fire({
                    title: "<font className='error_title'>Error</font>",
                    html: `${responseJSON.message}`,
                    icon: "error"
                });
            }
        } catch (error) {
            Swal.fire({
                icon:   "error",
                html:   error,
                title:  "Error",
            });
        }
    }

    const submitNewPassword = async (data) => {
        try {
            const response = await fetch(API_ROUTES.RESET_PASSWORD, {
                method: "POST",
                body: objectToFormData({
                    email: resetEmail,
                    reset_token: resetToken,
                    new_password: data.new_password,
                    new_password_confirmation: data.new_password_confirmation,
                }),
            });
            const responseJSON = await response.json();

            if (responseJSON.status.toString() === "200") {
                await Swal.fire({
                    title: 'Password Reset',
                    html: responseJSON.message || 'Your password has been reset successfully. Please login.',
                    icon: 'success',
                    timer: 2000,
                    showConfirmButton: false,
                });
                backToLogin();
            } else {
                Swal.fire({
                    title: "<font className='error_title'>Error</font>",
                    html: `${responseJSON.message}`,
                    icon: "error"
                });
            }
        } catch (error) {
            Swal.fire({
                icon:   "error",
                html:   error,
                title:  "Error",
            });
        }
    }


    const loginAuth = async (data) => {
        // console.log(data);
        // navigate("/dashboard");
        // return;
        try {
            const response = await fetch(API_ROUTES.SIGN_IN, {
                method: "POST",
                body: objectToFormData(data),
            });
            const responseJSON = await response.json();
            const message = responseJSON.message;

            if(responseJSON.status.toString() === "200"){
                const responseDetails = responseJSON.data;

                // console.log("responseJSONs ===> ", responseJSON);
                // console.log("responseJSONs ===> ", responseJSON.data.user_id);
                localStorage.setItem('user_id', responseJSON.data.user_id);



                const userData = {};
                userData.isLoggedIn = true;
                userData.responseDetails = responseDetails;

                if(responseDetails.twoFa_status === 1){ // is2FA
                    const response1 = await fetch(API_ROUTES.TWO_FA_TOKEN, {
                        method: 'POST',
                        body: objectToFormData(data),
                        headers: {'token': userData?.responseDetails?.token},
                    });
                    const responseJSON2 = await response1.json();
                    // console.log(responseJSON2);

                    const result = await Swal.fire({
                        title: '2 Factor Authentication! Enter the code sent to your email and continue',
                        html: `<div class="text-left swal_inputs swal_inputs_pass">
                                <input type="number" id="ccode" class="swal2-input" placeholder="Enter code">
                            </div>`,
                        confirmButtonText: 'Continue',
                        icon: 'question',
                        iconHtml: '?',
                        focusConfirm: false,
                        showCancelButton: true,
                        cancelButtonColor: '#999',
                        preConfirm: () => {
                            const ccode = Swal.getPopup().querySelector('#ccode').value
                            if (!ccode) {
                            Swal.showValidationMessage(`Please enter code sent to your email`);
                            return;
                            }
                            return { ccode: ccode }
                        }
                    })
                    if (result.isConfirmed) {
                        Swal.fire({
                            title: 'Processing...',
                            text: "Please wait a second for a response...",
                            icon: 'success',
                            showConfirmButton: false,
                            confirmButtonColor: '#027937',
                            cancelButtonColor: '#d33',
                        });
                        try {
                            const dataString = { 
                                twoFatoken: result.value.ccode,
                                email: userData?.responseDetails?.email,
                            };
                            const response = await fetch(API_ROUTES.TWO_FA_CHECK, {
                                method: 'POST',
                                body: objectToFormData(dataString),
                                headers: {'token': userData?.responseDetails?.token},
                            });
                            const responseJSON = await response.json();
                            if (responseJSON.status === 200) {
                                localStorage.setItem('userDataFs', JSON.stringify(userData));
                                const userInput = {};
                                userInput.email = btoa(data.email);
                                userInput.password = btoa(data.password);

                                if(isChecked){
                                    localStorage.setItem('userInputFs', JSON.stringify(userInput));
                                }else{
                                    localStorage.removeItem('userInputFs');
                                }
                                localStorage.setItem('rememberLoginFs', data.remember);

                                Swal.fire({
                                    title: 'Successful',
                                    html: "",
                                    icon: 'success',
                                    timer: 1000,
                                });
                                navigate("/dashboard");
                                return;
                            } else {
                                Swal.fire({
                                    title: 'Error',
                                    html: responseJSON.message || 'An error occurred during the POST request.',
                                    icon: 'error',
                                });
                                return;
                            }
                        } catch (error) {
                            Swal.fire({
                                title: 'Error',
                                text: error.message || 'An error occurred during the POST request.',
                                icon: 'error',
                            });
                            return;
                        }
                    };
                    
                }else{
                    localStorage.setItem('userDataFs', JSON.stringify(userData));
                    const userInput = {};
                    userInput.email = btoa(data.email);
                    userInput.password = btoa(data.password);

                    if(isChecked){
                        localStorage.setItem('userInputFs', JSON.stringify(userInput))
                    }else{
                        localStorage.removeItem('userInputFs');
                    }
                    localStorage.setItem('rememberLoginFs', data.remember);
                    navigate("/dashboard");
                }

                
            }else{
                Swal.fire({
                    title: "<font className='error_title'>Error</font>",
                    html: `${message}`,
                    icon: "error"
                });
            }
        } catch (error) {
            Swal.fire({
                icon:   "error",
                html:   error,
                title:  "Error",
            });
        }
    }

    return (
        <div className="container-fluid_">

            <Loaders />

            <div className="text-center" style={{ 
                position: 'absolute', 
                top: '20px', 
                right: '20px', 
                zIndex: 1000 
            }}>
                <a 
                    href="https://forthsoft.net/" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="btn"
                    style={{
                        background: 'linear-gradient(135deg, rgb(97, 27, 34) 0%, rgb(139, 39, 49) 100%)',
                        color: 'white',
                        padding: '12px 25px',
                        fontSize: '16px',
                        fontWeight: '700',
                        borderRadius: '50px',
                        textDecoration: 'none',
                        border: 'none',
                        boxShadow: '0 8px 20px rgba(97, 27, 34, 0.4)',
                        transition: 'all 0.3s ease',
                        textTransform: 'uppercase',
                        letterSpacing: '1px',
                        animation: 'pulse 2s infinite',
                        transform: 'translateY(0)',
                        position: 'relative',
                        overflow: 'hidden'
                    }}
                    onMouseEnter={(e) => {
                        e.target.style.transform = 'translateY(-2px) scale(1.05)';
                        // e.target.style.boxShadow = '0 12px 25px rgba(97, 27, 34, 0.6)';
                        // e.target.style.background = 'linear-gradient(135deg, rgb(139, 39, 49) 0%, rgb(97, 27, 34) 100%)';
                    }}
                    onMouseLeave={(e) => {
                        e.target.style.transform = 'translateY(0) scale(1)';
                        e.target.style.boxShadow = '0 8px 20px rgba(97, 27, 34, 0.4)';
                        e.target.style.background = 'linear-gradient(135deg, rgb(97, 27, 34) 0%, rgb(139, 39, 49) 100%)';
                    }}
                >
                    <span style={{ position: 'relative', zIndex: 2 }}>
                        🌐 Visit Website
                    </span>
                </a>
            </div>

            <style jsx>{`
                @keyframes pulse {
                    0% {
                        box-shadow: 0 8px 20px rgba(97, 27, 34, 0.4);
                    }
                    50% {
                        box-shadow: 0 8px 20px rgba(97, 27, 34, 0.7);
                    }
                    100% {
                        box-shadow: 0 8px 20px rgba(97, 27, 34, 0.4);
                    }
                }
                
                @media (max-width: 768px) {
                    .btn {
                        padding: 10px 20px !important;
                        fontSize: 14px !important;
                    }
                }
            `}</style>

            <div className="row mt-xs--10">
                
                <div className="col-xl-6 d-xl-block d-none"><img className="bg-img-cover bg-center" src={require('../images/login.jpg')} alt="looginpage" /></div>

                <div className="col-xl-6 p-0">
                    <div className="login-card login-dark pl-xs-90 pr-xs-90">
                        <div>
                            <div className="text-center_">
                                <a className="logo text-center" href="">
                                    <img className="img-fluids for-light" src={require('../images/logo2-black.png')} alt="logo" />
                                    {/* <img className="img-fluid htmlFor-dark" src={require('../images/logo2-black.png')} alt="logo" /> */}
                                </a>
                            </div>
                            {
                                showLogin &&
                                <div className="login-main mt--10 mt-xs-20"> 
                                    <form className="theme-form" onSubmit={handleSubmit(loginAuth)}>
                                        <h4>Sign in to your account</h4>
                                        <p style={{ fontSize:'15px' }}>Enter your login credentials</p>
                                        <div className="form-group mt-xs-20">
                                            <label className="col-form-label">Email Address</label>
                                            {errors.email && <label className="errors">{errors.email?.message}</label>}

                                            <input className="form-control" type="email" name="email" required="" placeholder="Enter email or phone" {...register("email", {
                                                required: "Your email or phone is required"
                                            })} />
                                        </div>

                                        <div className="form-group mt-15">
                                            <label className="col-form-label">Password</label>
                                            {errors.password && <label className="errors">{errors.password?.message}</label>}

                                            <div className="form-input position-relative">
                                                <input 
                                                className="form-control" 
                                                type={showPassword ? 'text' : 'password'} 
                                                name="password"
                                                placeholder="Enter password" 
                                                defaultValue={password}
                                                onChange={(e) => setPassword(e.target.value)}
                                                {...register("password", {required: "Your password is required"})} />
                                                <div className="show-hide" onClick={togglePassword}>{showPassword ? 'hide' : 'show'}</div>
                                            </div>
                                        </div>

                                        <div className="form-group mt-15 mb-10">
                                            <div className="checkbox p-0 ml-15 mb-20">
                                                <input id="checkbox1" type="checkbox" name="remember" />
                                                    <label className="text-muted" htmlFor="checkbox1" {...register('remember')} checked={isChecked} onChange={() => setIsChecked(!isChecked)}>Remember password</label>
                                            </div>

                                            <a className="link" href="#" onClick={forgotPassLink}>Forgot password?</a>

                                            <div className="text-end mt-15">
                                                <button className="btn btn-primary btn-block w-100" type="submit" disabled={isSubmitting || !isValid} style={{ opacity: isSubmitting ? '0.5' : 1 }}>{isSubmitting ? 'Signing In...' : 'Sign in'}</button>
                                            </div>
                                        </div>        
                                        {/* <p className="mt-4 mb-0 text-center">Don't have account?<a className="ms-2" href="sign-up.html">Create Account</a></p> */}
                                    </form>
                                </div>
                            }

                            {
                                showForgotPassword &&
                                <div className="login-main mt--10 mt-xs-20">
                                    <form className="theme-form" onSubmit={handleSubmitForgot(requestResetCode)}>
                                        <h4>Reset Your Password</h4>
                                        <p style={{ fontSize:'15px' }}>Enter your email associated with Forthsoft</p>
                                        <div className="form-group mt-xs-20">
                                            <label className="col-form-label">Email Address</label>
                                            {forgotErrors.email && <label className="errors">{forgotErrors.email?.message}</label>}

                                            <input className="form-control" type="email" placeholder="Enter your email address" {...registerForgot("email", {
                                                required: "Your email is required"
                                            })} />
                                        </div>
                                        <div className="form-group mt-30 mb-10">
                                            <div className="text-end mt-15">
                                                <button className="btn btn-primary login_btn btn-block w-100" type="submit" disabled={isSubmittingForgot || !isForgotValid} style={{ opacity: isSubmittingForgot ? '0.5' : 1 }}>{isSubmittingForgot ? 'Sending Code...' : 'Send Reset Code'}</button>
                                            </div>
                                        </div>
                                        <div className="text-center">
                                            <a href="#" onClick={backToLogin}>Go back</a>
                                        </div>
                                    </form>
                                </div>
                            }

                            {
                                showOtp &&
                                <div className="login-main mt--10 mt-xs-20">
                                    <form className="theme-form" onSubmit={handleSubmitOtp(verifyResetCode)}>
                                        <h4>Verify Code</h4>
                                        <p style={{ fontSize:'15px' }}>Enter the code sent to <strong>{resetEmail}</strong></p>
                                        <div className="form-group mt-xs-20">
                                            <label className="col-form-label">Verification Code</label>
                                            {otpErrors.reset_token && <label className="errors">{otpErrors.reset_token?.message}</label>}

                                            <input className="form-control" type="text" placeholder="Enter code" {...registerOtp("reset_token", {
                                                required: "The code sent to your email is required"
                                            })} />
                                        </div>
                                        <div className="form-group mt-15 mb-10">
                                            <div className="text-center">
                                                {
                                                    resendTimer > 0
                                                    ? <span className="text-muted">Resend code in {formatTimer(resendTimer)}</span>
                                                    : <a href="#" onClick={(e) => { e.preventDefault(); resendCode(); }}>Resend code</a>
                                                }
                                            </div>
                                        </div>
                                        <div className="form-group mt-15 mb-10">
                                            <div className="text-end mt-15">
                                                <button className="btn btn-primary login_btn btn-block w-100" type="submit" disabled={isSubmittingOtp || !isOtpValid} style={{ opacity: isSubmittingOtp ? '0.5' : 1 }}>{isSubmittingOtp ? 'Verifying...' : 'Verify Code'}</button>
                                            </div>
                                        </div>
                                        <div className="text-center">
                                            <a href="#" onClick={backToLogin}>Go back</a>
                                        </div>
                                    </form>
                                </div>
                            }

                            {
                                showResetPassword &&
                                <div className="login-main mt--10 mt-xs-20">
                                    <form className="theme-form" onSubmit={handleSubmitReset(submitNewPassword)}>
                                        <h4>Set New Password</h4>
                                        <p style={{ fontSize:'15px' }}>Your new password must be strong and secure</p>
                                        <div className="form-group mt-xs-20">
                                            <label className="col-form-label">New Password</label>
                                            {resetErrors.new_password && <label className="errors">{resetErrors.new_password?.message}</label>}

                                            <div className="form-input position-relative">
                                                <input
                                                className="form-control"
                                                type={showNewPassword ? 'text' : 'password'}
                                                placeholder="Enter new password"
                                                {...registerReset("new_password", {
                                                    required: "New password is required",
                                                    pattern: {
                                                        value: /^(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*(),.?":{}|<>_\-+=~`[\]\\/;']).{6,}$/,
                                                        message: "Password must be at least 6 characters and include an uppercase letter, a number, and a special character"
                                                    }
                                                })} />
                                                <div className="show-hide" onClick={toggleNewPassword}>{showNewPassword ? 'hide' : 'show'}</div>
                                            </div>
                                        </div>

                                        <div className="form-group mt-15">
                                            <label className="col-form-label">Confirm New Password</label>
                                            {resetErrors.new_password_confirmation && <label className="errors">{resetErrors.new_password_confirmation?.message}</label>}

                                            <div className="form-input position-relative">
                                                <input
                                                className="form-control"
                                                type={showConfirmPassword ? 'text' : 'password'}
                                                placeholder="Confirm new password"
                                                {...registerReset("new_password_confirmation", {
                                                    required: "Please confirm your new password",
                                                    validate: (value) => value === newPasswordValue || "Passwords do not match"
                                                })} />
                                                <div className="show-hide" onClick={toggleConfirmPassword}>{showConfirmPassword ? 'hide' : 'show'}</div>
                                            </div>
                                        </div>

                                        <div className="form-group mt-30 mb-10">
                                            <div className="text-end mt-15">
                                                <button className="btn btn-primary login_btn btn-block w-100" type="submit" disabled={isSubmittingReset || !isResetValid} style={{ opacity: isSubmittingReset ? '0.5' : 1 }}>{isSubmittingReset ? 'Resetting...' : 'Reset Password'}</button>
                                            </div>
                                        </div>
                                        <div className="text-center">
                                            <a href="#" onClick={backToLogin}>Go back</a>
                                        </div>
                                    </form>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}